<div class="top-images">
    <cx-page-slot position="OneTrustMediaSlot"></cx-page-slot>
</div>
<div class="row cookie-container">
    <div class="col-lg-12 col-md-12 col-sm-12">
        <cx-page-slot position="Section1"></cx-page-slot>
        <div class="text-cookie-color" [innerHtml]="apiRes"></div>
        <cx-page-slot position="Section2A"></cx-page-slot>
    </div>
</div>